export enum BenefitDocumentType {
    BOOKLET = 'BOOKLET',
    SCHEDULED_BENEFIT_SUMMARY = 'SCHEDULED_BENEFIT_SUMMARY'
}